import styled from "@emotion/styled";
import { Box as BoxRaw } from "@chakra-ui/react";

export const Box = styled(BoxRaw)`
  border: 1px solid ${({ theme }) => theme.colors["sk-light-gray"]};
  border-radius: 4px;
`;
